import React, { useEffect, useRef } from 'react';
import styles from './style.css';
interface IconProps extends React.SVGProps<SVGSVGElement> {
	size?: string | number;
	width?: string | number;
	height?: string | number;
	spin?: boolean;
	rtl?: boolean;
	color?: string;
	fill?: string;
	stroke?: string;
}

export default function Unionpay(props: IconProps) {
	const root = useRef<SVGSVGElement>(null);
	const {
		size = '1em',
		width,
		height,
		spin,
		rtl,
		color,
		fill,
		stroke,
		className,
		...rest
	} = props;
	const _width = width || size;
	const _height = height || size;
	const _stroke = stroke || color;
	const _fill = fill || color;
	useEffect(() => {
		if (!_fill) {
			(root.current as SVGSVGElement)
				?.querySelectorAll('[data-follow-fill]')
				.forEach((item) => {
					item.setAttribute(
						'fill',
						item.getAttribute('data-follow-fill') || ''
					);
				});
		}
		if (!_stroke) {
			(root.current as SVGSVGElement)
				?.querySelectorAll('[data-follow-stroke]')
				.forEach((item) => {
					item.setAttribute(
						'stroke',
						item.getAttribute('data-follow-stroke') || ''
					);
				});
		}
	}, [stroke, color, fill]);
	return (
		<svg
			ref={root}
			width={_width}
			height={_height}
			viewBox="0 0 40 40"
			preserveAspectRatio="xMidYMid meet"
			fill="none"
			role="presentation"
			xmlns="http://www.w3.org/2000/svg"
			className={`${className || ''} ${spin ? styles.spin : ''} ${rtl ? styles.rtl : ''}`.trim()}
			{...rest}
		>
			<g>
				<g clipPath="url(#11e7d6__a)">
					<path
						fill="#fff"
						d="M37.646 7.633H2.355A2.354 2.354 0 0 0 0 9.986v20.149c0 1.3 1.054 2.353 2.354 2.353h35.291c1.3 0 2.354-1.053 2.354-2.353V9.986c0-1.3-1.054-2.353-2.354-2.353Z"
					/>
					<path
						fill="#DE4447"
						d="m25.845 11.004-2.775-.001 2.76.001h.015Z"
					/>
					<path
						fill="#EC1C24"
						d="m12.444 27.26 3.282-14.52c.215-.948 1.419-1.718 2.374-1.739h-6.367c-.961 0-2.194.778-2.414 1.74L6.038 27.26c-.02.088-.031.174-.038.26v.27c.064.693.594 1.198 1.356 1.21h6.405c-.945-.015-1.534-.79-1.317-1.74Z"
					/>
					<path
						fill="#2A557C"
						d="M23.071 11.003 18.14 11l-.038.001 4.97.002Z"
					/>
					<path
						fill="#0071BB"
						d="m20.191 27.26 3.281-14.52c.216-.942 1.404-1.706 2.357-1.736l-2.759-.001L18.1 11c-.956.02-2.159.79-2.374 1.74l-3.283 14.52c-.217.95.373 1.724 1.318 1.739h7.748c-.946-.015-1.534-.79-1.318-1.74Z"
					/>
					<path
						fill="#009DA4"
						d="m32.785 11.005-6.937-.001h-.018c-.953.03-2.141.794-2.357 1.737l-3.281 14.52c-.216.95.372 1.724 1.318 1.739h7.29c.932-.047 1.837-.802 2.05-1.735l3.281-14.518c.219-.961-.383-1.742-1.345-1.742Z"
					/>
					<path
						fill="#fff"
						d="M18.234 21.58h.12c.111 0 .186-.036.22-.11l.314-.469h.839l-.175.308h1.005l-.127.473h-1.196c-.138.207-.308.304-.512.294H18.1l.135-.495Zm-.137.678h2.202l-.14.512h-.886l-.135.496H20l-.14.513h-.862l-.2.732c-.05.123.015.178.195.166h.702l-.13.476h-1.349c-.256 0-.343-.146-.263-.44l.256-.933h-.552l.14-.514h.55l.136-.494h-.527l.14-.514Zm3.515-1.26-.035.3s.416-.311.793-.311h1.395l-.534 1.93c-.044.221-.234.33-.569.33h-1.58l-.37 1.356c-.022.073.009.11.088.11h.311l-.114.42h-.79c-.304 0-.43-.09-.38-.273L20.872 21l.74-.001Zm1.18.546H21.55l-.15.52s.208-.15.555-.155c.345-.005.74 0 .74 0l.099-.365Zm-.45 1.209c.092.012.144-.025.15-.11l.076-.275h-1.247l-.104.385h1.125Zm-.84.623h.718l-.014.31h.192c.096 0 .144-.03.144-.091l.057-.201h.596l-.08.293c-.066.244-.245.371-.536.383h-.382l-.002.533c-.007.085.07.127.229.127h.359l-.116.421h-.863c-.242.011-.36-.103-.358-.348l.056-1.427Zm3.052-1.773.167-.588h.843l-.037.216s.43-.216.741-.216h1.042l-.166.588h-.164l-.785 2.765h.164l-.156.55h-.164l-.068.24h-.816l.068-.24h-1.61l.157-.55h.162l.786-2.765h-.164Zm.91 0-.215.748s.367-.142.683-.18c.07-.263.161-.568.161-.568h-.63Zm-.314 1.099-.216.784s.407-.2.687-.217c.08-.303.16-.567.16-.567h-.63Zm.158 1.666.16-.568h-.628l-.163.568h.63Zm2.037-3.388h.792l.034.293c-.005.074.039.108.133.108h.14l-.142.495h-.582c-.223.013-.337-.072-.347-.256l-.028-.64Zm-.232 1.062h2.565l-.15.532h-.816l-.14.494h.816l-.152.53h-.91l-.205.312h.445l.103.622c.012.062.067.092.162.092h.137l-.145.514h-.489c-.253.012-.384-.073-.395-.257l-.118-.567-.405.604a.439.439 0 0 1-.441.24h-.747l.146-.514h.233c.096 0 .175-.043.247-.129l.633-.917h-.816l.151-.53h.887l.14-.493h-.886l.15-.533Zm-14.318-3.616c-.098.478-.323.844-.674 1.105-.347.256-.795.385-1.343.385-.516 0-.894-.132-1.136-.394-.167-.187-.25-.425-.25-.711 0-.12.014-.247.042-.384l.585-2.817h.882l-.576 2.785a.891.891 0 0 0-.024.213.54.54 0 0 0 .106.35c.105.137.274.204.51.204.272 0 .496-.067.668-.2a.922.922 0 0 0 .339-.567l.578-2.785h.877l-.584 2.816Zm.812-1.109h.624l-.071.363.089-.104a.971.971 0 0 1 .738-.323c.262 0 .45.077.57.23.116.153.149.364.093.636l-.343 1.713h-.64l.31-1.553c.032-.16.023-.279-.027-.357-.048-.077-.14-.115-.275-.115a.599.599 0 0 0-.417.154.757.757 0 0 0-.225.427l-.286 1.445h-.642l.502-2.516Zm7.147 0h.624l-.07.363.088-.104a.973.973 0 0 1 .737-.323c.262 0 .452.077.57.23.116.153.15.364.092.636l-.341 1.713h-.642l.31-1.553c.032-.16.023-.279-.026-.357-.05-.077-.14-.115-.275-.115a.603.603 0 0 0-.417.154.757.757 0 0 0-.225.427l-.287 1.445h-.64l.502-2.516Zm-4.254.001h.692l-.542 2.514h-.69l.54-2.514Zm.218-.916h.697l-.13.61h-.697l.13-.61Zm1.085 3.239c-.18-.173-.272-.405-.273-.701a1.91 1.91 0 0 1 .037-.355c.082-.408.257-.733.525-.971.269-.24.593-.36.972-.36.31 0 .556.086.737.26.18.174.27.409.27.71a1.732 1.732 0 0 1-.038.36c-.08.403-.255.724-.523.96-.27.236-.593.353-.969.353-.312 0-.558-.085-.738-.256Zm1.317-.498c.122-.132.21-.332.262-.599a1.083 1.083 0 0 0 .026-.247.51.51 0 0 0-.119-.36.431.431 0 0 0-.335-.129.604.604 0 0 0-.47.203c-.124.134-.21.338-.266.61a2.91 2.91 0 0 0-.019.123.849.849 0 0 0-.005.117c0 .154.04.272.119.357.079.084.19.125.337.125a.611.611 0 0 0 .47-.2Zm4.718-3.385h1.81c.349 0 .617.08.803.234.184.156.276.382.276.675v.009c0 .055-.004.119-.009.187-.009.067-.02.135-.035.206-.08.388-.265.7-.551.936a1.555 1.555 0 0 1-1.018.354h-.972l-.3 1.474H23l.838-4.075Zm.452 1.894h.806c.21 0 .376-.05.498-.146.12-.097.2-.246.245-.448l.017-.102a.924.924 0 0 0 .006-.087c0-.144-.051-.249-.154-.314-.103-.067-.265-.098-.487-.098h-.684l-.247 1.195Zm6.2 2.668c-.265.564-.518.895-.667 1.047-.148.152-.445.505-1.154.478l.06-.43c.599-.185.922-1.016 1.106-1.383l-.22-2.708.462-.006h.388l.043 1.699.727-1.699h.736l-1.48 3.001Zm-2.058-2.797-.292.201c-.306-.24-.585-.387-1.124-.138-.733.34-1.346 2.95.673 2.09l.116.137.794.02.522-2.37-.689.06Zm-.452 1.296c-.127.376-.413.625-.636.555-.223-.07-.303-.433-.173-.81.128-.378.414-.626.636-.555.222.069.303.433.173.81Z"
					/>
				</g>
				<defs>
					<clipPath id="11e7d6__a">
						<path fill="#fff" d="M0 0h40v40H0z" />
					</clipPath>
				</defs>
			</g>
		</svg>
	);
}
